import { Edit } from "react-admin";
import { JobApplicationClosureReasonForm } from "./index";
import { EditToolbar } from "@components/EditToolbar";

export const JobApplicationClosureReasonEdit = () => (
  <Edit mutationMode="pessimistic">
    <JobApplicationClosureReasonForm toolbar={<EditToolbar showDeleteButton={false} />} />
  </Edit>
);
